import { create } from 'zustand';

interface JijelStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isMobileOpen?: boolean;
  setIsMobileOpen: (isMobileOpen: boolean) => void;
  isMobileImageOpen?: boolean;
  setIsMobileImageOpen: (isMobileImageOpen: boolean) => void;
}

export const useJijelStore = create<JijelStore>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
  isMobileOpen: false,
  setIsMobileOpen: (isMobileOpen) => set({ isMobileOpen }),
  isMobileImageOpen: false,
  setIsMobileImageOpen: (isMobileImageOpen) => set({ isMobileImageOpen }),
}));
